module.exports = __webpack_public_path__ + "img/icon-profile_logout.1bdfb273.png";